
      if (!window.__vectorsignalPreferLegacyWallboard) {
        import("/src/main.tsx");
      }
    